const Event = require('../Event')

class WebsiteEvent extends Event {
    constructor (props) {
        super(props)

        this.type = WebsiteEvent.TYPE

        this.sourceType = WebsiteEvent.SOURCE_TYPE
        this.source = WebsiteEvent.SOURCE
        
        this.journey = props.journey
        this.visit = props.visit

        this.uri = props.uri
        this.referrer = props.referrer

        this.browserName = props.browserName
        this.browserVersion = props.browserVersion

        this.browserOuterWidth = props.browserOuterWidth
        this.browserInnerWidth = props.browserInnerWidth

        this.browserOuterHeight = props.browserOuterHeight
        this.browserInnerHeight = props.browserInnerHeight
    }
}

WebsiteEvent.SOURCE_TYPE = 'website'
WebsiteEvent.SOURCE = 'website'
WebsiteEvent.TYPE = 'epi:website:event'

module.exports = WebsiteEvent
